import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from "element-ui"
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import util from '@/libs/util.js'
// 路由数据
// import routes from '../routerConfig'
import routes from './routes'

// import store from '@/store/index'
Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})
// 白名单路由
const whiteList = ['/shipGoods/shipGoodsApply', "/shipGoods/shipGoodsForm"];
/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  // 进度条
  NProgress.start()
  // if (whiteList.includes(to.path)) {
  //   next()
  //   return
  // }
  const userId = window.sessionStorage.getItem('userId')
  const isLoggedIn = userId && userId != null

  if (whiteList.includes(to.path)) {
    if (isLoggedIn) {
      next({ name: 'index' }) // Change 'home' to your desired redirect target
      NProgress.done()
      return
    } else {
      // Allow access to white-listed routes for non-logged-in users
      next()
      return
    }
  }
  // 验证当前路由所有的匹配中是否需要有登录验证的
  if (to.matched.some(r => r.meta.requireAuth)) {
    // 这里暂时将storage里是否存有userId作为验证是否登录的条件
    const userId = window.sessionStorage.getItem('userId');
    if (userId && userId != null) {
      if (JSON.parse(window.sessionStorage.getItem('initMenu')) && JSON.parse(window.sessionStorage.getItem('initMenu')) != undefined) {
        let notInMenu = false
        let menu = JSON.parse(window.sessionStorage.getItem('initMenu'));
        menu && util.traversalTree(menu, (item, list) => {
          // console.log(item.value + "----------"+item.path+"--------------"+to.name)
          let arr = to.name.split('_');
          if (item.value == to.name || item.path.indexOf(to.name) > 0 || arr.some(r => item.path.indexOf(r) > 0)) {
            // console.log(item.value + "----------"+item.path+"--------------"+to.name)
            to.meta.btnAuthList = item.btnAuthList
            to.meta.menuKidList = list
            notInMenu = false
            next()
            return true
          }
        })
        if (notInMenu) {
          next({
            name: '404'
          })
        }
      }
    } else {
      if (to.fullPath === '/transport/workbench') {
        next({
          path: 'transportDetil',
          name: 'transportDetil',
        });
        return false
      }
      // 将当前预计打开的页面完整地址临时存储 登录后继续跳转
      // 这个 cookie(redirect) 会在登录后自动删除
      util.cookies.set('redirect', from.fullPath)
      // 没有登录的时候跳转到登录界面
      Message({
        showClose: true,
        customClass: 'ajax-error',
        message: "请您登录之后再进行相关功能的操作",
        type: 'info',
        duration: 3 * 1000
      })
      next({
        name: 'login'
      })
    }
  } else {
    if (from.fullPath != '/login') {
      util.cookies.set('redirect', from.fullPath)
    }
    next()
  }
})

router.afterEach(to => {
  // 进度条
  NProgress.done()
  // 需要的信息
  const app = router.app
  // const { name, params, query } = to
  // 存储当前跳转的路由，以设置菜单的激活状态
  app.$store.commit('d2admin/page/currentSet', to.path)
  if (to.matched[0].path == '') {
    if (to.matched[1].path == "/transportDetil") {
      app.$store.commit('d2admin/menu/menuActiveSet', "/transport")
    } else {
      app.$store.commit('d2admin/menu/menuActiveSet', to.matched[1].path)
    }
  } else {
    app.$store.commit('d2admin/menu/menuActiveSet', to.matched[0].path)
  }
  // 更改标题
  util.title(to.meta.title)
})

export default router
